const BUILT_IN_FIELD_PREFIXES = ["page.", "group."];

const normalizePath = value => String(value || "").trim().toLowerCase();

export function collectAvailableFieldPaths(fieldGroups = {}) {
  return Object.values(fieldGroups || {})
    .flatMap(fields => (Array.isArray(fields) ? fields : []))
    .map(field => String(field?.fieldPath || "").trim())
    .filter(Boolean);
}

export function isReportFieldPathAvailable(fieldPath, availableFieldPaths = []) {
  const normalizedPath = normalizePath(fieldPath);

  if (!normalizedPath) return true;
  if (BUILT_IN_FIELD_PREFIXES.some(prefix => normalizedPath.startsWith(prefix))) {
    return true;
  }

  const normalizedAvailablePaths = availableFieldPaths.map(normalizePath);

  return normalizedAvailablePaths.some(
    availablePath =>
      availablePath === normalizedPath ||
      availablePath.startsWith(`${normalizedPath}.`)
  );
}

export function getUnavailableElementFieldPaths(
  element,
  availableFieldPaths = []
) {
  if (!element) return [];

  const paths = [];

  if (
    element.type === "field" ||
    element.type === "summaryTaxList" ||
    element.type === "summaryWithholdingList"
  ) {
    paths.push(element.fieldPath);
  }

  if (element.type === "groupHeaderBand" && element.groupFieldPath) {
    paths.push(element.groupFieldPath);
  }

  if (Array.isArray(element.columns)) {
    element.columns.forEach(column => paths.push(column?.fieldPath));
  }

  return [...new Set(
    paths
      .map(path => String(path || "").trim())
      .filter(Boolean)
      .filter(path => !isReportFieldPathAvailable(path, availableFieldPaths))
  )];
}
